const AVC_CODECS = ['avc1.640028', 'avc1.4d0033'];
let _videoCodecOverride = null;
function setVideoCodecOverride(codec) {
    _videoCodecOverride = codec;
}
function getVideoCodecOverride() {
    if (_videoCodecOverride !== null)
        return _videoCodecOverride;
    try {
        const href = typeof globalThis.location?.href === 'string'
            ? globalThis.location.href
            : '';
        if (!href)
            return null;
        return new URL(href).searchParams.get('videoCodec');
    }
    catch {
        return null;
    }
}
function resolveVideoCodecs(defaultCodecs) {
    if (getVideoCodecOverride() === 'avc')
        return AVC_CODECS;
    return defaultCodecs;
}
const Settings = {
    videoEncoderCodecs: [
        'hvc1.1.6.L93.90', // H.265/HEVC codec (widely supported)
        'avc1.4d0033', // H.264/AVC codec (widely supported)
        'avc1.420034',
    ],
    videoEncoderBitrateSd: 250_000, // broadcaster upload bw requirement (4x) 1Mbit/s
    videoEncoderBitrateHd: 1_500_000, // broadcaster upload bw requirement (4x) 6Mbit/s
    videoEncoderBitrateUhd: 3_000_000, // broadcaster upload bw requirement (4x) 12Mbit/s
    videoEncoderKeyFrameInterval: 30, // One keyframe per second at 30fps
    videoEncoderDefaultFrameRate: 30,
    videoEncoderDefaultWidth: 1280,
    videoEncoderDefaultHeight: 720,
    videoEncoderAnnexB: false,
    defaultHeartbeatInterval: 30000,
    speakerHeartbeatInterval: 5000,
    viewerCounterUpdateInterval: 1000,
    broadcastMetadataInterval: 10000,
    audioSampleRate: 48000,
    audioNumberOfChannels: 1,
    audioCodec: 'opus',
    audioFrameSize: 960,
    audioFrameDurationMicroseconds: 20000,
    // Viewer partition: composite HEVC video + Opus audio
    viewerStreamVideoCodecs: ['hvc1.1.6.L93.90'],
    viewerStreamVideoBitrate: 2_500_000,
    viewerStreamAudioCodec: 'opus',
    viewerStreamAudioBitrate: 128000,
    viewerStreamAudioChannels: 2,
    // RTMP output: composite AVC video + AAC audio
    rtmpVideoCodecs: ['avc1.4d0033', 'avc1.420034'],
    rtmpVideoBitrate: 5_000_000,
    rtmpAudioCodec: 'mp4a.40.2',
    rtmpAudioBitrate: 128000,
    rtmpAudioChannels: 2,
    // Speaker partition: per-track HEVC video + Opus audio
    speakerTrackVideoCodecs: ['hvc1.1.6.L93.90'],
    speakerTrackVideoBitrate: 500_000,
    speakerTrackAudioCodec: 'opus',
    // Per-role video defaults (resolution + bitrate for per-track encoding)
    cohostVideoWidth: 1920,
    cohostVideoHeight: 1080,
    cohostVideoBitrate: 1_500_000,
    cohostCallVideoWidth: 1280,
    cohostCallVideoHeight: 720,
    cohostCallVideoBitrate: 1_000_000,
    speakerVideoWidth: 1280,
    speakerVideoHeight: 720,
    speakerVideoBitrate: 1_000_000,
    guestVideoWidth: 640,
    guestVideoHeight: 360,
    guestVideoBitrate: 500_000,
    cameraVideoWidth: 1920,
    cameraVideoHeight: 1080,
    cameraVideoBitrate: 1_500_000,
    // Speech detection (voice activity)
    speechDetectionPollIntervalMs: 50,
    speechStartThreshold: 0.01,
    speechStopThreshold: 0.005,
    speechStartDebounceMs: 100,
    speechStopDebounceMs: 1000,
    // Dominant speaker tracking (receiver side)
    dominantSpeakerSwitchMargin: 0.05,
    dominantSpeakerSwitchDebounceMs: 500,
    // Signature verification policy
    videoVerificationSamplingRate: 0.1,
    maxFragmentSize: 64000, // 64KB - estimated size of protocol headers
    optimalDelayWindowLength: 60,
    optimalDelayMinSamplesToStart: 15,
    // Tail-aware: localhost WebRTC bunches frames into pairs, leaving ~80–100ms
    // tail gaps that p95 ignores. p99 + larger safety covers those tails.
    optimalDelayPercentile: 0.99,
    optimalDelaySafetyFactor: 0.3,
    optimalDelayMinSafetyMs: 50,
    optimalDelayUnderflowBoostMs: 40,
    optimalDelayUnderflowDecaySeconds: 5,
    optimalDelayDecreaseRate: 0.05,
    optimalDelayAutonomousDecreasePerSec: 5,
};

export { Settings, getVideoCodecOverride, resolveVideoCodecs, setVideoCodecOverride };
